import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { History, Trash2, RotateCw, TriangleAlert } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
};

export const SearchHistory = ({ history, activeId, onOpen, onDelete }) => {
  return (
    <Card className="shadow-[var(--shadow-card)] border-border/80">
      <CardHeader className="pb-3">
        <CardTitle className="font-heading text-lg flex items-center gap-2">
          <History className="h-5 w-5 text-primary" />
          Arama Geçmişi
        </CardTitle>
      </CardHeader>
      <CardContent className="px-2">
        {(!history || history.length === 0) && (
          <p className="px-2 py-4 text-sm text-muted-foreground">
            Henüz arama yok. Bir arama yapınca burada listelenir.
          </p>
        )}
        <ScrollArea className="max-h-[340px]">
          <div className="flex flex-col gap-1.5" data-testid={TESTIDS.searchHistory}>
            {history?.map((h) => (
              <div
                key={h.id}
                data-testid={`search-history-item-${h.id}`}
                className={`group rounded-lg border px-3 py-2.5 transition-colors cursor-pointer ${
                  activeId === h.id
                    ? "border-primary/50 bg-accent"
                    : "border-transparent hover:bg-secondary"
                }`}
                onClick={() => onOpen(h.id)}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <div className="truncate text-sm font-medium">{h.text_query}</div>
                    <div className="mt-0.5 text-xs text-muted-foreground">
                      {formatDate(h.created_at)}
                    </div>
                  </div>
                  <div className="flex items-center gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
                    <Button
                      variant="ghost"
                      size="icon"
                      className="h-7 w-7"
                      data-testid={`search-history-rerun-${h.id}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        onOpen(h.id);
                      }}
                      title="Aç"
                    >
                      <RotateCw className="h-3.5 w-3.5" />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      className="h-7 w-7 text-destructive"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(h.id);
                      }}
                      title="Sil"
                    >
                      <Trash2 className="h-3.5 w-3.5" />
                    </Button>
                  </div>
                </div>
                <div className="mt-1.5 flex items-center gap-3 text-xs">
                  <span className="text-muted-foreground">{h.summary?.total ?? 0} sonuç</span>
                  {(h.summary?.leads ?? 0) > 0 && (
                    <span className="inline-flex items-center gap-1 text-[hsl(var(--lead-fg))] font-medium">
                      <TriangleAlert className="h-3 w-3" />
                      {h.summary.leads} lead
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};
